// Keeps the first-run welcome flow visible after the first project is created
// so we can show the optional "add members" step before entering the CRM shell.
// Additive only — when null, Preview behaves exactly as before.

import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const CrmFirstRunContext = createContext({
  membersOnboarding: null,
  startMembersOnboarding: () => {},
  finishMembersOnboarding: () => {},
});

export function CrmFirstRunProvider({ children }) {
  const [membersOnboarding, setMembersOnboarding] = useState(null);

  const startMembersOnboarding = useCallback((project) => {
    if (!project?._id) return;
    setMembersOnboarding({
      projectId: String(project._id),
      projectName: project.name || "Untitled project",
    });
  }, []);

  const finishMembersOnboarding = useCallback(() => {
    setMembersOnboarding(null);
  }, []);

  const value = useMemo(() => ({
    membersOnboarding,
    startMembersOnboarding,
    finishMembersOnboarding,
  }), [membersOnboarding, startMembersOnboarding, finishMembersOnboarding]);

  return (
    <CrmFirstRunContext.Provider value={value}>
      {children}
    </CrmFirstRunContext.Provider>
  );
}

export function useCrmFirstRun() {
  return useContext(CrmFirstRunContext);
}
